import React from 'react';

const CGVPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-5xl font-black mb-8 text-[#e2b13c] text-center">
          Conditions Générales de Vente & RGPD
        </h1>

        <div className="bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg p-8 text-gray-200 space-y-8">
          {/* Article 1 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 1 : Tarifs et Paiement</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                Les tarifs affichés sur le site sont <strong>fixes et garantis</strong> dès la réservation. Ils incluent la TVA au taux de 10% et comprennent l'ensemble des frais liés à la prestation (carburant, péages, stationnement, temps d'attente raisonnable).
              </p>
              <p>
                Le paiement peut s'effectuer :
              </p>
              <ul className="list-disc ml-6 space-y-1">
                <li>Par carte bancaire ou espèces à bord du véhicule</li>
                <li>Par paiement en ligne sécurisé via Stripe (infrastructure bancaire certifiée)</li>
              </ul>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 2 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 2 : Majorations</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                Une majoration de <strong>8%</strong> est appliquée sur le tarif de base pour les trajets effectués les dimanches et jours fériés.
              </p>
              <p className="text-sm italic">
                Jours fériés concernés : 1er janvier, 1er mai, 8 mai, 14 juillet, 15 août, 1er novembre, 11 novembre, 25 décembre.
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 3 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 3 : Annulation et Modification</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                Le client peut annuler ou modifier sa réservation gratuitement jusqu'à <strong>24 heures avant</strong> l'heure de prise en charge prévue.
              </p>
              <p>
                En deçà de ce délai, toute annulation entraîne la facturation intégrale de la course.
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 4 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 4 : Frais de Dégradation</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                En cas de dégradation du véhicule (taches, détérioration, salissures importantes), des frais de remise en état d'un montant forfaitaire de <strong>150 €</strong> seront facturés au client.
              </p>
              <p className="text-sm italic">
                Ce montant couvre le nettoyage approfondi et/ou les réparations nécessaires.
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 5 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 5 : Responsabilité et Assurance</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                VTC des Weppes est couvert par une assurance Responsabilité Civile Professionnelle (Thélem Assurance, contrat TMRP13225089).
              </p>
              <p>
                Le chauffeur s'engage à acheminer le client dans les meilleures conditions de sécurité et de confort. Toutefois, la société ne saurait être tenue responsable en cas de retard indépendant de sa volonté (embouteillages, conditions météorologiques, etc.).
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 6 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 6 : Paiement en Ligne (Stripe)</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                Les paiements en ligne sont sécurisés par <strong>Stripe</strong>, plateforme de paiement certifiée PCI-DSS niveau 1 (norme de sécurité la plus élevée dans l'industrie du paiement).
              </p>
              <p>
                VTC des Weppes ne stocke aucune donnée bancaire. Les informations de paiement sont exclusivement traitées par Stripe.
              </p>
              <p>
                En cas de paiement en ligne, des frais de service web sécurisé peuvent être appliqués (indiqués lors de la réservation).
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 7 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 7 : Retard de Paiement</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                En cas de retard de paiement, une pénalité égale à <strong>3 fois le taux d'intérêt légal</strong> sera exigible, ainsi qu'une indemnité forfaitaire de 40 € pour frais de recouvrement.
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Article 8 */}
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Article 8 : Protection des Données Personnelles (RGPD)</h2>
            <div className="space-y-3 text-gray-300">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), les données personnelles collectées (nom, email, téléphone, adresses) sont exclusivement utilisées pour :
              </p>
              <ul className="list-disc ml-6 space-y-1">
                <li>La gestion et le suivi des réservations</li>
                <li>L'émission des factures</li>
                <li>La communication relative aux prestations</li>
              </ul>
              <p>
                Ces données ne sont jamais cédées à des tiers. Vous disposez d'un droit d'accès, de rectification et de suppression de vos données en contactant : <a href="mailto:contact@vtcdesweppeslille.fr" className="text-[#e2b13c] underline">contact@vtcdesweppeslille.fr</a>
              </p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          {/* Footer */}
          <div className="text-center pt-6">
            <p className="text-sm text-gray-400">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
            <p className="text-sm text-gray-400 mt-2">
              SAS VTC des Weppes - SIRET 918 489 659 00014
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;